module.exports = __webpack_public_path__ + "static/object-7-0b3b071ffba81b188aab1777c2e2f666.png";